import React, { useState } from "react";
import "./style.scss";
import Input from "../../elements/input";
import Checkbox from "../../elements/checkbox";
import PrimaryButton from "../../elements/primary-button";
import SimpleLink from "../../elements/simple-link";
import BodyText from "../../elements/body-text";
import PropTypes from "prop-types";
import ShippingInfoSummary from "../shipping-info-summary";

const CreateAccountCheckout = ({
  heading,
  email,
  password,
  firstName,
  lastName,
  phonenumber,
  checkboxNewsletter,
  checkboxTermsOfUse,
  submitButton,
  backButton,
  infoText,
  submitCreateAccount = () => {},
  accountExists,
  accountExistsMessage,
  phoneExists,
  phoneExixtsMessage,
  createAccountFailed,
  createAccountFailedMessage,
  isNetworkFailed,
  loginNetworkErrorMessage,
  registrationInProcessMessage,
  registrationInProcess,
  submitting
}) => {
  const [formDataPassword, setPassword] = useState();
  const [formDataNewsletter, setNesletterPreference] = useState();
  const [formDataAgreedToTerms, setAgreeToTerms] = useState();

  //mandatory fields
  const [passwordHasError, setPasswordHasError] = useState();
  const [agreedToTermsHasError, setAgreedToTermsHasError] = useState();

  // inside input validation errors
  const [passwordHasValidationError, setPasswordHasValidationError] = useState();
  // const [yourInfo, setInfo] = useState([]);
  const onPasswordChange = (evt, isValid) => {
    setPassword(evt.target.value);
    setPasswordHasValidationError(!isValid);
  };

  const onNesletterPreferenceChanged = checked => {
    setNesletterPreference(checked);
  };
  const onAgreeToTermsChanged = checked => {
    setAgreeToTerms(checked);
    setAgreedToTermsHasError(false);
  };

  const onPasswordHasFocus = () => {
    setPasswordHasError(false);
  };

  const dataIsValidToSubmit = () => {
    return !passwordHasError && !passwordHasValidationError && formDataAgreedToTerms;
  };

  const onSubmit = evt => {
    evt.preventDefault();
    const formData = {
      email,
      password: formDataPassword,
      subscribed: formDataNewsletter,
      agreedToTerms: formDataAgreedToTerms
    };

    if (!formDataPassword) {
      setPasswordHasError(true);
    }
    if (!formDataAgreedToTerms) {
      setAgreedToTermsHasError(true);
    }
    if (dataIsValidToSubmit()) {
      submitCreateAccount(evt, formData);
    } else {
      evt.target.focus();
    }
  };
  const info = { heading, rows: [`${firstName} ${lastName}`, email, phonenumber] };
  return (
    <form className={"checkout-create-account-form"}>
      <ShippingInfoSummary shippingAddress={info} />

      {password && (
        <Input
          {...{
            ...password,
            type: "password",
            showError: passwordHasError,
            onChange: (evt, isValid) => onPasswordChange(evt, isValid),
            onFocus: onPasswordHasFocus
          }}
        />
      )}
      {checkboxNewsletter && (
        <div className={"terms-checkbox"}>
          <Checkbox
            {...{
              ...checkboxNewsletter,
              onChange: onNesletterPreferenceChanged
            }}
          />
        </div>
      )}

      {checkboxTermsOfUse && (
        <div className={"terms-checkbox"}>
          <Checkbox
            {...{
              ...checkboxTermsOfUse,
              error: agreedToTermsHasError,
              onChange: onAgreeToTermsChanged
            }}
          />
        </div>
      )}

      {createAccountFailed && createAccountFailedMessage && <span className="failed-message">{createAccountFailedMessage.value}</span>}
      {isNetworkFailed && loginNetworkErrorMessage && <span className="failed-message">{loginNetworkErrorMessage.value}</span>}
      {accountExists && accountExistsMessage && <span className="failed-message">{accountExistsMessage.value}</span>}
      {phoneExists && phoneExixtsMessage && <span className="failed-message">{phoneExixtsMessage.value}</span>}
      {registrationInProcess && <span className="failed-message">{registrationInProcessMessage.value}</span>}
      {infoText && (
        <div className={"info-background"}>
          <BodyText className="disclaimer" html={infoText} />
        </div>
      )}

      <div className={"button-container"}>
        {submitButton && <PrimaryButton {...{ ...submitButton, isDisabled: submitting, callback: evt => onSubmit(evt) }} />}

        {backButton && <SimpleLink {...backButton} />}
      </div>
    </form>
  );
};

CreateAccountCheckout.propTypes = {
  heading: PropTypes.string,
  email: PropTypes.string,
  password: PropTypes.object,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  phonenumber: PropTypes.string,
  checkboxNewsletter: PropTypes.object,
  checkboxTermsOfUse: PropTypes.object,
  submitButton: PropTypes.object,
  backButton: PropTypes.object,
  infoText: PropTypes.string,
  submitCreateAccount: PropTypes.func,
  createAccountFailed: PropTypes.bool,
  createAccountFailedMessage: PropTypes.object
};

CreateAccountCheckout.defaultProps = {
  submitCreateAccount: () => {}
};

export default CreateAccountCheckout;
